// extracted by mini-css-extract-plugin
export default {"userItem":"UserItem_userItem__yM-zV","roletype":"UserItem_roletype__LN4+r","name":"UserItem_name__rzOVn"};